import { useNavigate } from 'react-router-dom';

import { exitModalText, homePath } from '@/theme/vars';
import { setIsExitLocationModalOpen, setShouldShowGuestSignUpModal } from '@/state/features/app';
import { useAppDispatch, useAppSelector } from '@/state/store';
import { useAudio } from '@/hooks/audio';
import Modal from '@/components/Modal';
import ThemedButton from '@/components/ThemedButton';

export default function ExitModal() {
    const { audio } = useAudio();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const isExitLocationModalOpen = useAppSelector((state) => state.app.isExitLocationModalOpen);
    return (
        <Modal
            title="Head back?"
            onClose={() => {
                dispatch(setIsExitLocationModalOpen(false));
            }}
            isVisible={isExitLocationModalOpen}
        >
            <ThemedButton
                text={exitModalText}
                onClick={() => {
                    dispatch(setIsExitLocationModalOpen(false));
                    dispatch(setShouldShowGuestSignUpModal(true));
                    navigate(homePath);
                }}
                disabled={!isExitLocationModalOpen}
            />
        </Modal>
    );
}
